var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 4.58749C14.3165 5.2754 15.2477 6.33725 15.7742 7.60834C16.3008 8.87943 16.3931 10.2887 16.037 11.6177C15.6809 12.9466 14.8963 14.1209 13.8048 14.9585C12.7132 15.796 11.3758 16.25 10 16.25C8.62416 16.25 7.28677 15.796 6.19524 14.9585C5.10372 14.1209 4.31906 12.9466 3.96297 11.6177C3.60687 10.2887 3.69924 8.87943 4.22575 7.60834C4.75227 6.33725 5.68349 5.2754 6.875 4.58749M10 3.75V8.55763",
    stroke: "#2B2B2B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.b20672b589665193561979ba69a92c63.svg";
export { ForwardRef as ReactComponent };